(function () {
    'use strict';

    //definimos el binding bidireccional (=)
    angular
        .module('app')
        .component('buscadorAvanzado', {

            bindings: {
                ediciones: '=',
                tipologias: '<',
                subgeneros: '<',
                modalidades: '<',
                tamanos:'<',
                onBuscar: '<',
                onClear: '<',
                filter: '<'
            },
            templateUrl: 'app/public/components/buscador/buscador.avanzado.html',
            controller: "BuscadorControllerComponent",
            controllerAs: 'ctrl'
        });

})();
